module.exports = __webpack_public_path__ + "static/img/rjpc-banner.09ddd422.png";